<template lang="pug">
v-list
  v-list-item.sdo-radius.card-hover.mb-1.px-2(
    v-for="[type, agreement] in Object.entries(agreements)"
    :key="agreement.id"
    :disabled="agreement.disabled"
    @click="openModulePreview(agreement, idx)"
  )
    v-list-item-icon.mr-4: v-icon(
      size="40"
      :color="agreement.id ? 'success' : 'grey'"
    ) {{ agreement.id ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}
    v-list-item-content
      .caption.grey--text {{ CONTRACT_TYPES_NAMES[agreement.type] }}
      .text-body-2: strong {{ agreement.title }}
      //- .text-body-2( v-if="agreement.prepayment_percent")
      //-   span.mr-2 Авансирование:
      //-   span.text-body-1: strong {{ agreement.prepayment_percent }}%
    v-list-item-icon
      v-icon(color="secondary" small) mdi-pencil

</template>

<script>
import AgreementModal from '@/modules/PaymentSystem/components/AgreementModal.vue';
import { CONTRACT_TYPES_NAMES } from '../constants';

export default {
  props: {
    agreements: { type: Object, default: () => [] },
  },
  data() {
    return {
      CONTRACT_TYPES_NAMES,
    };
  },

  methods: {

    openModulePreview(moduleItem, idx) {
      this.$modals.show('generic-controller', {
        title: moduleItem.title,
        dialogProps: {
          width: 800,
        },
        component: AgreementModal,
        'component-props': {
          onDelete: () => this.$emit('delete'),
          successCallback: (form) => {
            const method = form.id ? 'updateTypicalContract' : 'saveTypicalContract';
            if (form.document) {
              form.document = {
                filename: form.document.file_name,
                original_name: form.document.file_name,
              };
            }
            this.$rHandler(
              this.$api.contracts[method](form, form.id),
              ({ data }) => {
                this.$emit('update', data.data, idx);
                this.$modals.close();
              },
              () => {
                this.$modals.close();
              },
            );
          },
          moduleItem,
          subscribed: !!moduleItem.user_status,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.stock-item {

  &--description {
    height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}
</style>
